module.exports = __webpack_public_path__ + "img/roleA.6273e950.png";